<h2
    mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="email_personinfo_heading"
></h2>
<mat-dialog-content class="email-archive-dialog-content">
    <tt-email-person-info-form [email]="data.email" (submit)="dialogRef.close($event)"></tt-email-person-info-form>
</mat-dialog-content>
